export function printOeeModal(body) {
    if (!body) return;
    const source = body.closest('.modal-content');
    if (!source) return;
    const printWindow = window.open('', '_blank', 'width=1200,height=800');
    if (!printWindow) {
        window.alert('Please allow pop-ups to print this report.');
        return;
    }
    const content = source.cloneNode(true);
    content.querySelectorAll('button, .modal-footer, colgroup').forEach(element => element.remove());
    content.querySelectorAll('details').forEach(element => element.setAttribute('open', ''));
    const title = source.querySelector('.modal-title');
    printWindow.document.open();
    printWindow.document.write(`<!doctype html><html><head><meta charset="utf-8"><style>
        @page { size: A4 landscape; margin: 10mm; }
        * { box-sizing: border-box; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
        body { font: 9pt Arial, sans-serif; color: #212529; margin: 0; }
        .modal-title { font-size: 16pt; font-weight: bold; margin-bottom: 12pt; }
        h5 { font-size: 11pt; margin: 14pt 0 6pt; }
        p { margin: 6pt 0; }
        table { border-collapse: collapse; width: 100% !important; min-width: 0 !important; table-layout: fixed !important; margin: 8pt 0; font-size: 8pt; }
        th, td { border: 1px solid #999; padding: 4pt; min-width: 0 !important; width: auto !important; white-space: normal !important; overflow-wrap: anywhere; vertical-align: top; position: static !important; }
        th { text-align: left; background: #eee; }
        thead { display: table-header-group; }
        tfoot { display: table-row-group; }
        tr { break-inside: avoid; }
        .modal-body, .modal-content, .table-responsive, [role="region"] { overflow: visible !important; max-height: none !important; height: auto !important; }
        .text-danger { color: #b02a37 !important; }
        .text-muted { color: #555; }
        summary { font-weight: bold; }
        .alert { border: 1px solid #999; padding: 8pt; margin: 8pt 0; }
        .alert-warning { color: #664d03; background-color: #fff3cd; border-color: #ffecb5; }
    </style></head><body>${content.innerHTML}</body></html>`);
    printWindow.document.title = title ? title.textContent : 'OEE calculation';
    printWindow.document.close();
    printWindow.addEventListener('afterprint', () => printWindow.close(), { once: true });
    printWindow.focus();
    printWindow.print();
}
